import { createApp } from 'vue';
import App from './ServiceList.vue';
import {useTippy} from '../../../_helpers/vue-tippy';

document.querySelectorAll('[data-service-list]').forEach((el) => {
    const app = createApp(App);
    app.config.globalProperties.$config = JSON.parse(el.dataset.serviceList);

    useTippy(app);

    app.mount(el);
});
